import React from 'react'
import Lottie from 'react-lottie'
import { Col, Row } from 'antd'
import * as animationData from '@assets/Animation/getting_supply_options.json'

export const SupplyLoadingAnim = ({ message = 'Best Buy is looking for your most optimal price options.' }) => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData.default,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  }

  return (
    <div className='loading-container'>
      <Row>
        <Col>
          <Lottie options={defaultOptions} height={400} width={400} isStopped={false} isPaused={false} />
        </Col>
      </Row>
      <div className='option-loading-message'>{message}</div>
    </div>
  )
}
